const alwaysFalse = () => false as const;

export default alwaysFalse;
